module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Authors_Note"
    }
  }, [_c('p', {
    staticClass: "fm-title1"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("AUTHOR’S NOTE")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("With sincere thanks to the contributors to this book as well as to Grub Street Publishing who have allowed me rather more latitude than is probably traditional for the genre. Their openness and enthusiasm have been illuminating. With sincere thanks, too, to aviation artist Chris Stone whose painting appears on the front jacket cover of this book.")])])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66330b90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Authors_Note.vue
// module id = 72
// module chunks = 0